/* eslint-disable import/no-anonymous-default-export */
import axios, { AxiosError } from "axios"
import { CodigoInfraccion } from "../../codigos-infraccion/hooks/useCodigosInfraccionAPI"
import { Tag } from "../../common/components/TagInput"
import useApi, { ActionResult, Api, Model, Query, Response } from "../../common/hooks/useApi"
import { TipoExportacion } from "../../configuraciones-produccion/useConfiguracionesProduccionAPI"
import { Equipo } from "../../equipos/useEquiposAPI"
import { LoteConsulta } from "../../lotes-consulta/useLoteConsultaAPI"
import { LoteExportacion } from "../../lotes-exportacion/useLotesExportacionAPI"
import { OverlaySvg } from "../../overlays-svg/useOverlaysSvgAPI"
import { TitularVehiculo, TitularVehiculoCallCenter } from "../../titulares-vehiculo/useTitularesVehiculoAPI"
import { Descargo, EstadoJuzgado } from '../../juzgado/hooks/useDescargosAPI';
import { Sentencia } from '../../juzgado/hooks/useDescargosAPI';
import { LoteImpresion } from "../../lotes-impresion/useLotesImpresionAPI"
import { ConvenioPago, ConvenioPagoInfraccion } from "../../convenios-pago/useConveniosPagoAPI"
import { Interface } from "readline"

export type InfraccionGroupType = ("UNIDAD_PRODUCCION" | "EQUIPO" | "YEAR" | "MONTH" | "DAY");

export type EstadoInfraccion = (
    "PENDIENTE" |
    "RENOMBRADA" |
    "CONSULTANDO" |
    "CONSULTADA" |
    "VERIFICADA" |
    "EXPORTADA" |
    // "ACTA_GENERADA" |
    "IMPRESION_GENERADA" |
    "DESCARTADA"
);

export interface FilterReincidenciaProps {
    LimiteInfraccionesTotal?: number
    LimiteInfraccionesPeriodo?: number
    DiasPeriodo?: number
    ProvinciaTitular?: string
    CodigoPostalTitular?: string
};

export interface InfraccionAgrupada {
    equipoNombre: string
    equipoUnidadProduccion: string
    anio: number
    mes: number
    dia: number
    cantidadInfracciones: number
    cantidadInfraccionesRenombradas: number
    cantidadInfraccionesVerificadas: number
    cantidadInfraccionesDescartadas: number
}

export interface DetectionData {
    top: number;
    left: number;
    width: number;
    height: number;
}

export interface DetectionAreas {
    [key: string]: DetectionData;
}


export interface Infraccion extends Model {
    ValorMedido: number
    ValorMaximoPermitido: number
    UnidadMedida: string
    Descargo?: Descargo
    EstadoJuzgamiento?: EstadoJuzgado
    Sentencia?: Sentencia
    ConveniosPagosInfraccion: ConvenioPagoInfraccion[]    
    Lugar: string
    FechaHora?: string
    ImagenDestacadaIndice: number

    EstadoPago: ("IMPAGA" | "PAGADA")

    NoDistinguible?: boolean

    Patente: string
    PatenteX: number
    PatenteY: number
    PatenteZoom: number
    Extranjero: boolean
    Estado: EstadoInfraccion
    Equipo: Equipo
    //RenombradorAsignado: Usuario,
    ImagenPatente?: { FullUrl: string },
    Imagenes?: { FullUrl: string, Overlay?: OverlaySvg, Id: number, IsDeleted?: boolean }[]
    Videos?: { FullUrl: string, Overlay?: OverlaySvg, Id: number, IsDeleted?: boolean }[]
    AreasDeteccionImagenes?: DetectionAreas | any
    LoteConsulta: LoteConsulta
    NroTramite: string
    Titular: TitularVehiculo
    LoteExportacion: LoteExportacion           
    LoteImpresionId: number | null
    CodigoInfraccion?: CodigoInfraccion
    CodigoInfraccionId?: number
    ImpresionExcluida?: boolean
    FechaVencimiento?: string
    Fecha2doVencimiento?: string
    FechaImpresionGenerada?: string
    ValorUF?: number
    CotizacionUF?: number
    GastosAdministrativos?: number
    PorcentajeDescuentoPagoVoluntario?: number
    PlanPagosAplicado?: boolean
    PlanPagosPorcentaje?: number
    PlanPagosCobradorNombre?: string
    PlanPagosCobradorApellido?: string
    PlanPagosFecha?: string
    CuilTitular:string
    mantenerValores:boolean

    EtiquetasImagenes?: { EtiquetaIndex: string, Etiqueta: Tag }[]
    OverlaysImagenes?: OverlaySvg[]

    Correo?: { Estado: string, FechaEstado:Date, CodigoEstado:number }
}

export interface InfraccionesCallCenter extends Model {
    NroTramite: string;
    Patente: string;
    FechaInfraccion: string;
    FechaEmision: string;
    EstadoPago: ("IMPAGA" | "PAGADA");
    regenerada: number;
    vencimientoPagoVountario: string;
    ValorUF: number;
    CotizacionUF: number;
    PorcentajeDescuentoPagoVoluntario: number;
    GastosAdministrativos: number;
    Fecha2doVencimiento: string;
    Lugar: string;
    EstadoCorreoPostal: string | null;
    articuloCodigo: string;
    descripcionCodigo: string;
    referenciaPago: string;
    linkPago: string;
    estado?: EstadoInfraccion
    //Titular: TitularVehiculoCallCenter
    descargo?: {
        fechaPresentacion: string;
        fechaResolucion: string;
        estado: number;
        infraccionId: number;
        descripcionMotivo: string;
        documentoResolucion: {
            archivoDescargo: string | null;
            nombreArchivoOriginal: string;
            nroResolucion: string;
            file: string | null;
            filePath: string | null;
            baseUrl: string;
            pathUrl: string;
            name: string;
            extension: string;
            sizeBytes: number;
            fullUrl: string;
            id: number;
            createdAt: string;
            updatedAt: string;
            deletedAt: string | null;
            isDeleted: boolean;
        };
        id: number;
        createdAt: string;
        updatedAt: string;
        deletedAt: string | null;
        isDeleted: boolean;
    };
    unidadProduccionNombre: string;

    imagenes?: { FullUrl: string, Overlay?: OverlaySvg, Id: number, IsDeleted?: boolean }[]

    videos?: { FullUrl: string, Overlay?: OverlaySvg, Id: number, IsDeleted?: boolean }[]
}

export interface LinkPagoInfo {
  numero_operacion: string;
  id_transaccion: number;
  url_qr: string;
  codigo_link: string;
  codigo_pmc: string;
  respuesta_entidad_cobro: string;
  codigo_pago_fp: string;
  codigo_barras_fp: string;
  fechavenc_fp: string;
  descripcion: string | null;
  importe_fp: number;
}

export interface InfraccionesCallCenterRequest {
    Patente?: string;
    DniCuit?: string;
    ApellidoNombre?: string;
    FechaInfraccionDesde?: string; // ISO string e.g. "2024-07-10T00:00:00"
    FechaInfraccionHasta?: string;
    EstadoPago?: number;
    NroTramite?: string;
    UnidadProduccion?: number;
    EstadoVencimiento?: number;
    EstadoJuzgamiento?: EstadoJuzgado;
    Estado?: number;
    fechaRango?: string;
    vencimiento?: number;
    FechaVencimiento?: string;
    TipoPersona?: number;
}


export default () => {
    const module = "Infraccion";
    const api = useApi({ module });

    return {
        count: (query: Query) => api.count(query),
        list: (query: Query) => api.list!<Infraccion>(query),        
        save: (data: Partial<Infraccion>) => api.save!<Partial<Infraccion>, Infraccion>(data),
        delete: (id: number) => api.delete!<Infraccion>(id),        
        //VerCantidadPendienteRenombrado
        getConsultaPendienteCount: async (query?: Query): Promise<ActionResult<number>> => {
            try {
                let qs = api.queryToString(query ?? {});
                const response = await api.axiosInstance.get<{ value: number }>(`${module}/VerCantidadConsultaPendiente?${qs}`);
                return {
                    data: { value: response.data.value }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },

        loadCompressedImages: async (): Promise<ActionResult<undefined>> => {
            try {
                await api.axiosInstance.post(`${module}/CargarImagenesComprimidas`);
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }

        },
        /*
        assignPending: async (RenombradorId: number, query?: Query): Promise<ActionResult<undefined>> => {
            try {
                let qs = api.queryToString(query ?? {});
                await api.axiosInstance.post(`${module}/AsignarRenombrado?${qs}`, { RenombradorId });
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },*/

        verify: async (id: number, titularId: number) => {
            try {

                const response = await api.axiosInstance.post(`${module}/Verificar/${id}`, { TitularId: titularId });
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        discard: async (id: number) => {
            try {

                const response = await api.axiosInstance.post(`${module}/Descartar/${id}`);
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        sendToQuery: async (id: number) => {
            try {

                const response = await api.axiosInstance.post(`${module}/EnviarAConsulta/${id}`);
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        getQueriedInfraciones: async (query?: Query) => {
            try {
                const defaultQuery: Query = { $count: true, $orderby: ["UpdatedAt asc"] };
                let qs = api.queryToString(query ? { ...query, ...defaultQuery } : defaultQuery);
                const response = await api.axiosInstance.get<Response<Infraccion[]>>(`${module}/InfraccionesEnVerificacion?${qs}`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        getQueriedInfracionesGroup: async (query?: Query, groupType?: InfraccionGroupType, loteConsulta?: string) => {
            try {
                const defaultQuery: Query = {};
                let qs = api.queryToString(query ? { ...query, ...defaultQuery } : defaultQuery);
                const response = await api.axiosInstance.get<InfraccionAgrupada[]>(`${module}/InfraccionesEnVerificacion/Agrupar?${qs}&groupType=${groupType}&loteConsulta=${loteConsulta}`);
                return {
                    data: { value: response.data }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        getVerificadasCount: async (type: TipoExportacion, query?: Query): Promise<ActionResult<number>> => {
            try {
                let qs = api.queryToString(query ?? {});
                const response = await api.axiosInstance.get<{ value: number }>(`${module}/VerCantidadVerificada?tipo=${type}&${qs}`);
                return {
                    data: { value: response.data.value }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },

        getReadyToPrintCount: async (query?: Query, filtersReincidencia?: FilterReincidenciaProps): Promise<ActionResult<number>> => {
            try {
                let qs = api.queryToString(query ?? {});
                if (filtersReincidencia) {
                    qs += filtersReincidencia.LimiteInfraccionesTotal != null ? `&LimiteInfraccionesTotal=${filtersReincidencia.LimiteInfraccionesTotal}` : '';
                    qs += filtersReincidencia.LimiteInfraccionesPeriodo != null ? `&LimiteInfraccionesPeriodo=${filtersReincidencia.LimiteInfraccionesPeriodo}` : '';
                    qs += filtersReincidencia.DiasPeriodo != null ? `&DiasPeriodo=${filtersReincidencia.DiasPeriodo}` : '';
                    qs += filtersReincidencia.ProvinciaTitular != null ? `&ProvinciaTitular=${filtersReincidencia.ProvinciaTitular}` : '';
                    qs += filtersReincidencia.CodigoPostalTitular != null ? `&CodigoPostalTitular=${filtersReincidencia.CodigoPostalTitular}` : '';
                }

                const response = await api.axiosInstance.get<{ value: number }>(`${module}/VerCantidadParaImpresion?${qs}`);
                return {
                    data: { value: response.data.value }
                };
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },

        listInfraccionesParaImpresion: async (query?: Query, filtersReincidencia?: FilterReincidenciaProps) => {
            try {
                let qs = api.queryToString(query ?? {});
                if (filtersReincidencia) {
                    qs += filtersReincidencia.LimiteInfraccionesTotal != null ? `&LimiteInfraccionesTotal=${filtersReincidencia.LimiteInfraccionesTotal}` : '';
                    qs += filtersReincidencia.LimiteInfraccionesPeriodo != null ? `&LimiteInfraccionesPeriodo=${filtersReincidencia.LimiteInfraccionesPeriodo}` : '';
                    qs += filtersReincidencia.DiasPeriodo != null ? `&DiasPeriodo=${filtersReincidencia.DiasPeriodo}` : '';
                    qs += filtersReincidencia.ProvinciaTitular != null ? `&ProvinciaTitular=${filtersReincidencia.ProvinciaTitular}` : '';
                    qs += filtersReincidencia.CodigoPostalTitular != null ? `&CodigoPostalTitular=${filtersReincidencia.CodigoPostalTitular}` : '';
                }

                const response = await api.axiosInstance.get<Response<Infraccion[]>>(`${module}/InfraccionesParaImpresion?${qs}`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        getPdfInfraccion: async (infraccionId: number | string) => {
            try {
                const headers = {
                    "Authorization": `bearer ${localStorage.getItem("_token")}`
                };
                const url = api.baseAxiosConfig.baseURL;
                const modifiedUrl = url!.replace("/odata/v1", "");
                const response = await axios.get(`${modifiedUrl}/VerPdfJuzgado?Id=${infraccionId}`, {
                    headers
                });
                return response.data;
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        getEstadisticasPagos: async (confProduccionIds:number[], selectedMonth: number, selectedYear: number, now: string) => {
            const confProduccionFilter = confProduccionIds.map(id => `'${id}'`).join(",")            
            const responsePagasMes = await api.list!<Infraccion>({
                $count: true,
                $top: 0,
                $filter: [`EstadoPago eq 'PAGADA'`, 
                "Estado eq 'IMPRESION_GENERADA'", 
                `Equipo/ConfiguracionProduccionId in (${confProduccionFilter})`, 
                `YEAR(FechaImpresionGenerada) eq ${selectedYear}`, 
                `MONTH(FechaImpresionGenerada) eq ${selectedMonth}`]
            });
            if (responsePagasMes.error) return {error:responsePagasMes.error}
            const responseImpagasMes = await api.list!<Infraccion>({
                $count: true,
                $top: 0,
                $filter: [`EstadoPago eq 'IMPAGA'`, 
                "Estado eq 'IMPRESION_GENERADA'", 
                `Equipo/ConfiguracionProduccionId in (${confProduccionFilter})`,                
                `${now} gt FechaVencimiento`,
                `YEAR(FechaImpresionGenerada) eq ${selectedYear}`, 
                `MONTH(FechaImpresionGenerada) eq ${selectedMonth}`]
            });
            if (responseImpagasMes.error) return {error:responseImpagasMes.error}
            const responsePagas = await api.list!<Infraccion>({
                $count:true,
                $top:0, 
                $filter:["EstadoPago eq 'PAGADA'", 
                    "Estado eq 'IMPRESION_GENERADA'",
                    `Equipo/ConfiguracionProduccionId in (${confProduccionFilter})`], 
                })
            if (responsePagas.error) return {error:responsePagas.error}
            const responseImpagas = await api.list!<Infraccion>({
                $count:true,
                $top:0, 
                $filter:["EstadoPago eq 'IMPAGA'", 
                    "Estado eq 'IMPRESION_GENERADA'",
                    `Equipo/ConfiguracionProduccionId in (${confProduccionFilter})`, 
                    `${now} gt FechaVencimiento`]
                })
            if (responseImpagas.error) return {error:responseImpagas.error}

            const pagasMes = responsePagasMes.data?.["@odata.count"]            
            const impagasMes = responseImpagasMes.data?.["@odata.count"];
            const totalMes = pagasMes! + impagasMes!;
            const pagas = responsePagas.data?.["@odata.count"]!
            const impagas = responseImpagas.data?.["@odata.count"]!            
            const total = pagas + impagas            
            return {
                pagasMes, impagasMes, totalMes, pagas, impagas, total
            }
        },
        downloadUpdateActa: async(infraccionId:number, diasVencimiento: number, mantenerValores:boolean) => {
            try {
                const response = await api.axiosInstance.post<Response<string>>(`${module}/RegenerarPdf?infraccionId=${infraccionId}&descuento=${0}&regenerarPago=${true}&diasVencimiento=${diasVencimiento}&mantenerValores=${mantenerValores}`,);
                return response;
            } 
            catch (error: any | AxiosError) {
                return error;
            }
        },
          getInfraccionesCallCenter: async (data:InfraccionesCallCenterRequest): Promise<InfraccionesCallCenter[]> => {
            try {
                var response = (await api.axiosInstance.post<InfraccionesCallCenter[]>(`${module}/callcenter`, data));
                return response.data ?? [];
                // return {
                //     data: { value: response.data.value }
                // };
            } catch (error: any | AxiosError) {

                return [];
            }

        },
        checkDuplicada:async (infraccionId:number): Promise<{duplicada: boolean, msg:string, sugerencia:string} | undefined> => {
            try {
                var response = await api.axiosInstance.get<{duplicada: boolean, msg:string, sugerencia:string}>(`${module}/checkduplicada/${infraccionId}`);
                return response.data;
            } catch (error) {
                return {duplicada: false, msg: `Error: ${error}`, sugerencia: ''};
            }
        },
        infraccionDetalle:async (infraccionId:number):Promise<any> => {
            try {
                var response = await api.axiosInstance.get<any>(`${module}/detalle/${infraccionId}`);
                console.log(response.data)
                return response.data;
            } catch (error) {
                console.log(error)
            }
        },
        regenerarLoteMasivo: async (ids: number[], diasVencimiento: number = 0, mantenerValores: boolean = false) => {
            try {
                const body = {
                    infraccionesIds: ids,
                    diasVencimiento,
                    mantenerValores
                };
                const response = await api.axiosInstance.post(`/Infraccion/RegenerarMasivo`, body, { responseType: 'blob' });

                const cantidadEmails = response.headers['x-cantidad-emails'] || '0';
                const fecha = new Date();
                const fechaStr = `${fecha.getFullYear()}_${String(fecha.getMonth() + 1).padStart(2, '0')}_${String(fecha.getDate()).padStart(2, '0')}`;
                const filename = `regeneracion_${fechaStr}_correos_${cantidadEmails}.csv`;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                return { error: false };
            } catch (error) {
                return { error: true, data: error };
            }
        }
    };
}